/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ExternalUserInformation' store object.
 * @namespace ExternalUserInformationSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAExternalUserInformation';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserInformationSelectors
   */
  static fetchSdUserInfo = state => state[selectors.moduleIdentifier].fetchSdUserInfo.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserInformationSelectors
   */
  static isFetchingFetchSdUserInfo = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdUserInfo.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserInformationSelectors
   */
  static fetchSdUserInfoError = state =>
    state[selectors.moduleIdentifier].fetchSdUserInfoError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserInformationSelectors
   */
  static fetchSdUserLocalOfficeAddress = state =>
    state[selectors.moduleIdentifier].fetchSdUserLocalOfficeAddress.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserInformationSelectors
   */
  static isFetchingFetchSdUserLocalOfficeAddress = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdUserLocalOfficeAddress.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserInformationSelectors
   */
  static fetchSdUserLocalOfficeAddressError = state =>
    state[selectors.moduleIdentifier].fetchSdUserLocalOfficeAddressError.payload;
}
